"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceApi = exports.ServiceResponseBodyApiDomain = exports.ServiceResponseHeadersApiDomain = exports.ServiceRequestBodyApiDomain = exports.ServiceRequestQueriesApiDomain = exports.ServiceRequestHeadersApiDomain = void 0;
const isNil_1 = __importDefault(require("lodash/isNil"));
const http_method_1 = require("./http-method");
// =============================================================================
// Request
// =============================================================================
class ServiceRequestHeadersApiDomain {
}
exports.ServiceRequestHeadersApiDomain = ServiceRequestHeadersApiDomain;
class ServiceRequestQueriesApiDomain {
}
exports.ServiceRequestQueriesApiDomain = ServiceRequestQueriesApiDomain;
class ServiceRequestBodyApiDomain {
}
exports.ServiceRequestBodyApiDomain = ServiceRequestBodyApiDomain;
// =============================================================================
// Response
// =============================================================================
class ServiceResponseHeadersApiDomain {
}
exports.ServiceResponseHeadersApiDomain = ServiceResponseHeadersApiDomain;
class ServiceResponseBodyApiDomain {
}
exports.ServiceResponseBodyApiDomain = ServiceResponseBodyApiDomain;
// =============================================================================
// API
// =============================================================================
class ServiceApi {
    /**
     * Asserts that the service specs are filled up corretly
     */
    assertValidations() {
        if (!this.internalPath.startsWith("/")) {
            throw new Error('internalPath must begin with "/"');
        }
        if (!this.path.startsWith("/")) {
            throw new Error('path must begin with "/"');
        }
        if (!this.path.includes(this.internalPath)) {
            throw new Error("path must contain internalPath");
        }
        if (this.method === http_method_1.HttpMethod.POST && (0, isNil_1.default)(this.requestContentType)) {
            throw new Error("POST method must have a requestContentType");
        }
    }
}
exports.ServiceApi = ServiceApi;
//# sourceMappingURL=service-api.js.map